var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":!_vm.isEmpty(_vm.appErrors.error),"top":true,"timeout":3200,"color":"red"}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-alert")]),_c('span',{staticClass:"text-md-body-1"},[_vm._v(_vm._s(_vm.appErrors.error))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }